import React from "react";
import { get } from "lodash";
// import { dateToViewFormat } from "../../utils/date";
import Editor from "../SunEditor";
import { shallowEqual, useSelector } from "react-redux";



// const data = JSON.parse(localStorage.getItem('TEST_DATA'));
// const TaskCommonDraftPrint2 = () => {
const TaskCommonDraftPrint2 = ({ data }) => {


  const company = useSelector((store) => store.Profile.company, shallowEqual);

  return <>{
    data && company && <div className="task-common-draft-print-wrap2">

      <div className="document-approvals">
        <h1 className="title">
          {company.name}
        </h1>
      </div>

      <div className="document-header">
        <div className="doc-options">
          <span className="label">문서번호 :</span>&nbsp;
          {get(data, 'data.draft.docNum', "&nbsp;")}&nbsp;
          <br />
          <span className="label">처리기간 :</span>&nbsp;
          {get(data, 'data.draft.processingPeriod', "&nbsp;")}&nbsp;
          <br />
          <span className="label">시행일자 :</span>&nbsp;
          {get(data, 'data.draft.effectiveDate', "&nbsp;")}&nbsp;
          <br />
          <span className="label">보존년한 :</span>&nbsp;
          {get(data, 'data.draft.retentionYear', "&nbsp;")}&nbsp;
          <br />
          <span className="label">경&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;유 :</span>&nbsp;
          {get(data, 'data.draft.through', "&nbsp;")}
          <br />
          <span className="label">수&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;신 :</span>&nbsp;
          {get(data, 'data.draft.receive', "&nbsp;")}
          <br />
          <span className="label">참&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;조 :</span>&nbsp;
          {get(data, 'data.draft.refer', "&nbsp;")}
        </div>

        <div className="references-wrap">
          <table className="table">
            <colgroup>
              <col width="10%" />
              <col width="20%" />
              <col width="20%" />
              <col width="10%" />
              <col width="40%" />
            </colgroup>
            <tr>
              <th>선<br />결</th>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <th>지<br />시</th>
              <td>&nbsp;</td>
            </tr>
          </table>
          <table className="table mt--1">
            <colgroup>
              <col width="10%" />
              <col width="15%" />
              <col width="25%" />
              <col width="10%" />
              <col width="20%" />
              <col width="20%" />
            </colgroup>
            <tr>
              <th rowSpan={2}>접<br />수</th>
              <th>일&nbsp;&nbsp;자<br />시&nbsp;&nbsp;간</th>
              <td>&nbsp;</td>
              <th rowSpan={3}>결<br />재<br />공<br />람</th>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>번&nbsp;&nbsp;호</th>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th colSpan={2}>처&nbsp;&nbsp;리&nbsp;&nbsp;과</th>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th colSpan={2}>담&nbsp;&nbsp;당&nbsp;&nbsp;자</th>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
          </table>
        </div>
      </div>


      <div className="document-contnets">
        {/* <div className="references-wrap display-table">
        <div className="display-table-row">
          <div className="display-table-cell th">
            참&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;조
          </div>
          <div className="display-table-cell td">
            {references.map((reference, i) => <>
              {i > 0 ? ', ' : ''}
              {get(reference, 'approverEmployee.companyGrade.name', ' ')}
              {reference.approverEmployee.name}
            </>)}
          </div>
        </div>
      </div> */}

        <div className="doc-instructions">
          <div className="doc-title">
            제&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;목 :&nbsp;&nbsp;
            {get(data, 'data.draft.title', "&nbsp;")}
          </div>
        </div>
        <div className="doc-content">

          <Editor
            readOnly={true}
            value={get(data, 'data.draft.content', "&nbsp;")}
          />
        </div>

        <h1 className="title">
          {company.name}
        </h1>
      </div>
    </div>
  }</>;
};
export {
  TaskCommonDraftPrint2,
};
export default TaskCommonDraftPrint2;
